import React from "react";
import "./Tag.scss";

import { ReactComponent as CloseIcon } from 'static/icons/close.svg';

const Tag = ({
  title,
  isWithoutRemovebutton,
  onRemoveTag,
}) => {
  

  return (
    <div className="tag">
      <p className="tag__text">
        {title}
      </p>

      <div
        className="tag__icon-wrapper"
        onClick={onRemoveTag}
      >
        <CloseIcon className="tag__icon"/>
      </div>
    </div>
  );
};

export default Tag;
